<template>
    <div class="configure-multiple-trials-view">
      <custom-drug-trials-configuration></custom-drug-trials-configuration>
    </div>
</template>
  
  <script>
  import CustomDrugTrialsConfiguration from '@/components/trial/CustomDrugTrialsConfiguration'
  
  export default {
    name: 'ConfigureMultipleTrialsView',
    components: {CustomDrugTrialsConfiguration},
  }
  </script>
  
  <style lang="stylus" scoped>
  </style>
  